import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { useSelector } from 'react-redux';

import Navbar from '../js/components/Navbar/Navbar';
import SmoothScroll from './extra/SmoothScroll';
import Error404 from './extra/Error404';
import LoadingScreen from './extra/LoadingScreen';
import HomePage from '../js/pages/HomePage';
import MakersharksReviewPage from '../js/pages/Makersharks/MakersharksReviewPage';
import SigninPage from '../js/pages/AuthPages/SigninPage';
import AboutUsPage from '../js/pages/AboutUsPage';
import Verification from '../js/pages/AuthPages/Verification';
import RoleSelectScreen from '@/js/pages/AuthPages/RoleSelectScreen';
import SignUpPage from '../js/pages/AuthPages/SignUpPage';
import SigninVerification from '@/js/pages/AuthPages/SigninVerification';
import ForgotPasswordPage from '@/js/pages/AuthPages/ForgotPasswordPage';
import ResetPasswordPage from '@/js/pages/AuthPages/ResetPasswordPage';
import GoogleRedirectPage from '@/js/pages/AuthPages/GoogleRedirectPage';
import BuyerDashboard from '@/js/pages/Buyer/BuyerDashboard';
import BookDemo from '@/js/pages/BookDemo';
import DocuSignPage from '@/js/pages/DocuSignPage';
import DocuFormPage from '@/js/pages/DocuFormPage';

const DefaultLayout = () => {
  const { isLoggedIn, userData, isVerified } = useSelector(
    (state) => state.authReducer,
  );

  // Check if user needs to select a role
  const [isLoading, setIsLoading] = useState(false);

  // Default role to 'buyer' if none exists

  return (
    <div className="flex flex-col justify-between">
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <div className="fixed top-0 left-0 w-full z-50">
            <Navbar />
          </div>
          <div className="mt-16">
            <SmoothScroll>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="about" element={<AboutUsPage />} />
                <Route path="book-demo" element={<BookDemo />} />

                <Route path="docuseal" element={<DocuSignPage />} />
                <Route path="docuseal-form" element={<DocuFormPage />} />

                {/* Auth routes */}
                <Route path="signin" element={<SigninPage />} />
                <Route path="signup" element={<SignUpPage />} />
                <Route path="forgotPassword" element={<ForgotPasswordPage />} />
                <Route path="reset-password" element={<ResetPasswordPage />} />
                <Route
                  path="oauth/google/callback"
                  element={<GoogleRedirectPage />}
                />

                {/* Protected routes */}
                <Route
                  path="signup/verification"
                  element={
                    isLoggedIn && !isVerified ? (
                      <Verification />
                    ) : (
                      <Navigate
                        to={
                          isLoggedIn
                            ? userData?.role
                              ? `/${userData.role}/dashboard`
                              : '/roles'
                            : '/'
                        }
                      />
                    )
                  }
                />
                <Route
                  path="signin/verification"
                  element={
                    isLoggedIn && !isVerified ? (
                      <SigninVerification />
                    ) : (
                      <Navigate
                        to={
                          isLoggedIn
                            ? userData?.role
                              ? `/${userData.role}/dashboard`
                              : '/roles'
                            : '/'
                        }
                      />
                    )
                  }
                />

                <Route
                  path="roles"
                  element={
                    isLoggedIn && isVerified && !userData?.role ? (
                      <RoleSelectScreen />
                    ) : (
                      <Navigate
                        to={
                          isLoggedIn && userData?.role
                            ? `/${userData.role}/dashboard`
                            : '/'
                        }
                      />
                    )
                  }
                />

                <Route path="/404" element={<Error404 />} />
                <Route path="*" element={<Navigate to="/404" />} />
              </Routes>
            </SmoothScroll>
          </div>
        </>
      )}
    </div>
  );
};

export default DefaultLayout;
